'use client'

import { useMapboxContext } from '@component/mapbox/map/context'
import { map } from 'lodash-es'
import { useEffect } from 'react'

export default function PolygonLabel({
  data,
  color = '#FF8500'
}) {

  const { id, map, mapLoaded } = useMapboxContext()
  const selfId = `${id}-polygon-label`

  useEffect(() => {
    if (!mapLoaded) return

    addPolygonLabel(map, selfId, color, data)
    return () => {
      map.removeLayer(selfId)
    }
  }, [mapLoaded, map, selfId, color, data])
}

function addPolygonLabel(map, id, color, data) {

  if (data.length === 0) return

  const sourceData = getSourceData(data)
  if (map.getSource(id)) {
    map.getSource(id).setData(sourceData)
  } else {
    const polygonLabelData = {
      'id': id,
      'type': 'symbol',
      'source': {
        'type': 'geojson',
        'data': sourceData
      },
      'layout': {
        'text-field': ['format', ['get', 'description'], { 'font-scale': 0.9 }],
        'icon-rotate': {
          'property': 'rotate',
          'stops': [[0, 0], [200, 200]]
        }
      },
      'paint': {
        'text-color': color,
        'text-halo-color': 'white',
        'text-halo-width': 2,
        'text-halo-blur': 2
      }
    }
    map.addLayer(polygonLabelData)
  }
}

function getSourceData(data) {
  return {
    'type': 'FeatureCollection',
    'features': map(data, item => (
      {
        'type': 'Feature',
        'properties': {
          'description': `${item.distance}m`,
          'angle': item.angle
        },
        'geometry': {
          'type': 'Point',
          'coordinates': item.midLatlon
        }
      }
    ))
  }
}
